module.exports = __webpack_public_path__ + "static/media/PDF-05.655d9824.webp";